// extracted by mini-css-extract-plugin
export default {"column":"VerticalCollage_column__2MaDD","track":"VerticalCollage_track__MWR2O","scroll-up":"VerticalCollage_scroll-up__uE+m7"};